import React, { useContext } from 'react';
import SectionBlock from './SectionBlock';
import { IconFlashL } from '../../../icons';
import { MatchingDialogContext } from '../configs';
import { distinguishBetweenMatchingEntries, getEntriesDictionary, showSection } from '../utils';
import { commonDisciplines } from '../../../marketplace-custom-config';

const disciplinesDictionary = commonDisciplines.reduce(
    (acc, discipline) => ({ ...acc, [discipline.key]: discipline.label }),
    {}
);

const SectionDisciplines = () => {
    const {
        scoreData,
        categorySelected,
        horseImage,
        riderProfileImage,
        riderListing,
        horseListing,
    } = useContext(MatchingDialogContext);

    const diciplineScore = scoreData?.baseScoreBreakdown?.diciplineScore;

    if (!diciplineScore) return null;

    const { shouldBeShown } = showSection({
        categorySelected,
        ...diciplineScore,
    });

    if (!shouldBeShown) return null;

    const riderListingPublicData = riderListing?.attributes?.publicData || {};
    const horseListingPublicData = horseListing?.attributes?.publicData || {};

    const riderListingDiciplines = (riderListingPublicData?.desiredDisciplines || []).map(
        disciplineKey => ({
            entry: disciplinesDictionary[disciplineKey],
            image: riderProfileImage,
        })
    );

    const horseListingDiciplines = (horseListingPublicData.desiredDisciplines || []).map(
        disciplineKey => ({
            entry: disciplinesDictionary[disciplineKey],
            image: horseImage,
        })
    );

    const entriesDictionary = [...riderListingDiciplines, ...horseListingDiciplines].reduce(
        getEntriesDictionary,
        {}
    );

    const { matchingEntries, nonMatchingEntries } = distinguishBetweenMatchingEntries(
        entriesDictionary,
        commonDisciplines
    );

    return (
        <SectionBlock scoreData={scoreData}>
            <SectionBlock.Header>
                <IconFlashL />
                <span>Disziplinen</span>
            </SectionBlock.Header>
            <SectionBlock.ScoreBadge sectionScoreData={diciplineScore} />
            <section>
                {[...matchingEntries, ...nonMatchingEntries].map(
                    ([entryKey, { matches, images }], index, arr) => (
                        <>
                            <SectionBlock.ScoreLine
                                key={`discipline-${index}`}
                                matches={matches}
                                lineLabel={entryKey}
                                avatars={images.map((image, index) => (
                                    <SectionBlock.ScoreLineAvatar
                                        key={`discipline-image-${index}`}
                                        avatarUrl={image}
                                    />
                                ))}
                            />
                            {index < arr.length - 1 && <SectionBlock.Delimiter />}
                        </>
                    )
                )}
            </section>
        </SectionBlock>
    );
};

export default SectionDisciplines;
